import { createStore, applyMiddleware, compose } from 'redux'
import thunk from 'redux-thunk'
import { apiMiddleware } from 'redux-api-middleware'
import { composeWithDevTools } from 'redux-devtools-extension'
import { fromJS, Map } from 'immutable'

import rootReducers from './reducers'

let initialState = fromJS({})
if (!Map.isMap(initialState)) {
  initialState = fromJS(initialState)
}

const middleware = [thunk, apiMiddleware]

const composedEnhancers = compose(composeWithDevTools(applyMiddleware(...middleware)))

const store = createStore(rootReducers, initialState, composedEnhancers)

export default store



// WEBPACK FOOTER //
// ./src/store.js